/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ allocated: NonNullable<unknown>, total: NonNullable<unknown>, unit: NonNullable<unknown> }} Stock_Out_Line_MismatchInputs */

const vi_stock_out_line_mismatch = /** @type {(inputs: Stock_Out_Line_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng phân bổ chưa khớp: ${i?.allocated}/${i?.total} ${i?.unit}`)
};

/**

* @param {Stock_Out_Line_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_line_mismatch = /** @type {((inputs: Stock_Out_Line_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Line_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_line_mismatch(inputs)
});